module.exports = __webpack_public_path__ + "img/three.0092e296.svg";